<template>
  <div class="progress-bar" v-if="shouldDisplay()">
    <p v-if="!isFinished">
      Section {{ currentSectionNumber }}
      <span v-if="numberOfSectionQuestionsAnswered > 0"
        >- {{ numberOfSectionQuestionsAnswered }} of
        {{ numberOfQuestionsInCurrentSection }} answered</span
      >
    </p>
    <p v-else>{{ totalSectionCount }} of {{ totalSectionCount }} answered</p>
    <div class="progress-bar__bar">
      <div
        class="progress-bar__bar__progress"
        v-bind:style="{
          width: 'calc(' + getSectionPercentageComplete + '% - 2px)'
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import store from "../store";

export default {
  store: store,
  props: ["current_section"],
  name: "ProgressBar",
  methods: {
    shouldDisplay() {
      if (this.hcData) {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {
    numberOfSections() {
      return store.getters.hcData.sections.length;
    },
    currentSectionNumber() {
      return store.getters.currentSectionNumber + 1;
    },
    currentQuestionNumber() {
      return store.getters.currentQuestionNumber + 1;
    },
    numberOfSectionQuestionsAnswered() {
      return this.currentQuestionNumber - 1;
    },
    numberOfQuestionsInCurrentSection() {
      if (store.getters.currentSectionNumber >= 0) {
        return store.getters.hcData.sections[store.getters.currentSectionNumber]
          .questions.length;
      } else {
        return 0;
      }
    },
    hcData() {
      return store.getters.hcData;
    },
    getSectionPercentageComplete() {
      try {
        if (!this.isFinished) {
          return (
            (this.numberOfSectionQuestionsAnswered /
              this.numberOfQuestionsInCurrentSection) *
            100
          );
        } else {
          return 100;
        }
      } catch (e) {
        return 0;
      }
    },
    isFinished() {
      return store.getters.isFinished;
    },
    totalSectionCount() {
      return store.getters.hcData.sections.length;
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
.progress-bar {
  display: flex;
  position: absolute;
  transition: top 0.3s ease;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 18px;
  color: white;
  align-items: center;
  font-size: 16px;
  line-height: 13px;
  justify-content: center;

  @media (max-width: 767px) {
    position: relative;
    color: #0000ff !important;
    top: -73px !important;
    justify-content: flex-start;
    opacity: 0.5;
  }

  p {
    margin: 0;
  }

  &__bar {
    border: 1px solid white;
    width: 81px;
    height: 16px;
    border-radius: 8px;
    margin-left: 14px;

    @media (max-width: 767px) {
      border-color: #0000ff;
    }

    &__progress {
      height: 12px;
      background-color: white;
      border-radius: 6px;
      margin: 1px;
      min-width: 12px;

      @media (max-width: 767px) {
        background-color: #0000ff;
      }
    }
  }
}
</style>
